/* global jQuery:false */
// expand / collapse agenda rows
(function ($) {
	"use strict";

	$(".title-speaker-container").on("click", function(event){
		if ($(event.currentTarget).hasClass("expanded")) {
			$(event.currentTarget).removeClass("expanded").addClass("collapsed");
			$(event.currentTarget).parent(".description").find(".abstract").addClass("hidden");
		} else if ($(event.currentTarget).hasClass("collapsed")) {
			$(event.currentTarget).removeClass("collapsed").addClass("expanded");
			$(event.currentTarget).parent(".description").find(".abstract").removeClass("hidden");
		}
	});

}(jQuery));

// agenda tab functionality
(function ($) {
	"use strict";

	$(".tablink").on("click", function(event){
		var tabId = $(event.currentTarget).attr("data-tab-id");
		$(".tablink").removeClass("active");
		$(event.currentTarget).addClass("active");
		$(".tab-content").addClass("hidden");
		$("#"+tabId).removeClass("hidden");
	});

	// if hash value containing tab ID exists, trigger a click on the tab
	var hash = window.location.hash.replace(/#|\//gi, "");
	$('[data-tab-id="'+hash+'"]').click();

}(jQuery));


// session filter functionality
(function ($) {
	"use strict";

	$(".filter-link").on("click", function(event){
		// toggle display of filter link
		if ($(event.currentTarget).hasClass("active")) {
			$(event.currentTarget).removeClass("active");
		} else {
			$(event.currentTarget).addClass("active");
		}

		var filters =[];

		// create array of active filters
		$(".filter-link.active").each(function (index, element) {
			filters.push($(element).attr("data-filter-id"));
		});

		// hide all sessions
		$(".tab-content-wrapper tr").addClass("hidden");

		// show filtered sessions
		$(".tab-content-wrapper tr").each(function (index, element) {
			var filterId = $(element).attr("data-filter-id");

			if ($.inArray(filterId, filters) !== -1) {
				$(element).removeClass("hidden");
			}
		});

		// display no results message
		$(".agenda-table").each(function(index, atable){
			var totaltr = $(atable).find("tr");
			var hiddentr = $(atable).find("tr.hidden");

			if(totaltr.length == hiddentr.length){
				$(atable).find(".no-results").removeClass("hidden");
			}
		});
	});

	$(".clear-all a").on("click", function () {
		$(".filter-link").each(function (index, element) {
			$(element).removeClass("active");
			$(".tab-content-wrapper tr").removeClass("hidden");
			$(".tab-content-wrapper tr.no-results").addClass("hidden");
		});
	});

}(jQuery));
